import Coffee from '@/models/coffee';

export class CoffeeClass {
  private _list: Coffee[] = [];
  private _group_intensity: any = {};
  constructor(list: any[]) {
    this._list = list.map((item: any) => {
      const { rID, rTitle, rProp } = item;
      let props: any = {};
      let group_intensity: any = {};
      Object.keys(rProp).forEach((key: string) => {
        if (rProp[key]['group_intensity']) {
          group_intensity[key] = parseInt(rProp[key]['group_intensity']);
          this._group_intensity[key] =
            group_intensity[key] > (this._group_intensity[key] || 0)
              ? group_intensity[key]
              : this._group_intensity[key];
          delete rProp[key]['group_intensity'];
        }
        props[key] = rProp[key];
      });
      const coffee: Coffee = {
        name: rTitle,
        code: rID,
        group_intensity,
        ...props,
      };
      return coffee;
    });
  }

  public get list(): Coffee[] {
    return this._list;
  }

  public get group_intensity(): any {
    return this._group_intensity;
  }
}
